import React from 'react'
import { Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import icon from '../../img/icon.png'
import tmp_user from '../../img/user.jpg'
import { Popover, PopoverBody } from 'reactstrap'
/* REDUX */
import { connect } from 'react-redux'
import { logoutUser } from '../../actions/auth'

class PopoverInner extends React.Component {
	render() {
		let cookies = new Cookies()
		let user_id = cookies.get('username')
		return (
			<ul>
				<li><Link to={"/profile/" + user_id}>My Profile</Link></li>
				<li><Link to={"/profile/" + user_id + "/upvotes"}>My Favorites</Link></li>
				<li><Link to={"/profile/" + user_id + "/bookmarked"}>My Saved</Link></li>
				<li><hr/></li>
				<li><Link to={"/settings"}>Settings</Link></li>
				<li><Link to={"/manage"}>My Reports</Link></li>
				<li><hr/></li>
				<li><a href="" onClick={ this.props.logoutUser }>Logout</a></li>
			</ul>
		)
	}
}

class UserNav extends React.Component {
	
	constructor(props) {
		super(props)		
		this.state = {
			popoverOpen: false
		}
		this.toggle = this.toggle.bind(this)
	}
	
	toggle() {
		this.setState({
			popoverOpen: !this.state.popoverOpen
		})
	}
  
	render() {
		let cookies = new Cookies()
		let user_img = cookies.get('user_img') && cookies.get('user_img') != 'undefined' ?  cookies.get('user_img') : 'https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=32da20ee-1450-44b5-ad37-04b317d18f04'
		return (
			<div className="profile-picture">
				<div id="popoverNav" onClick={ this.toggle }>
					<img src={ user_img } />
				</div>
				 <Popover placement="bottom" isOpen={ this.state.popoverOpen } target="popoverNav" toggle={ this.toggle }>
					<PopoverBody className="popover-content"><PopoverInner logoutUser={ this.props.logoutUser } /></PopoverBody>
				</Popover>
			</div>
		)
	}
}

class Navbar extends React.Component {
	
	render() {
				
		const isLoggedIn = this.props.authenticated
		
		return (
			<section id="navbar">
				<div className="container">
					<nav className="navbar navbar-horizon">
						<div className="left d-flex align-items-center">
							<Link className="icon" to={"/"}><img src={ icon } /></Link>
							<Link className="title" to={"/"}>
								<strong>The Flight Post</strong>
								<span>Your destination for trip reports</span>
							</Link>
						</div>
						{ isLoggedIn ? (
							<ul className="navbar-nav ml-auto">
								<li className="nav-item mr-2 d-flex">
									<Link className="link d-flex align-items-center" to={"/editor/new"}>Write a report</Link>
								</li>
								<li className="nav-item mr-2 d-flex">
									<span className="link-border d-flex align-items-center">|</span>
								</li>
								<li className="nav-item">
									<UserNav logoutUser={ this.props.logoutUser } />
								</li>
							</ul>
						) : (
							<ul className="navbar-nav ml-auto">
								<li className="nav-item mr-2 d-flex">
									<Link className="link d-flex align-items-center" to={"/editor/new"}>Write a report</Link>
								</li>
								<li className="nav-item mr-2 d-flex">
									<span className="link-border d-flex align-items-center">|</span>
								</li>
								<li className="nav-item mr-2">
									<a className="btn btn-link-o" onClick={ this.props.onLogin }>Log In</a>
								</li>
								<li className="nav-item">
									<a className="btn btn-link" onClick={ this.props.onSignup }>Sign Up</a>
								</li>
							</ul>
						)}
					</nav>
				</div>
			</section>
		)
	}
}

const mapStateToProps = (state) => {
	return {
	    authenticated: state.auth.authenticated
	}
}

export default connect(mapStateToProps, { logoutUser })(Navbar)


// WEBPACK FOOTER //
// ./src/components/Global/Navbar.js